module.exports = __webpack_public_path__ + "img/CrossChainBridge_icon5.3bdcfc53.svg";